<template>
<main>
    <breadcrumbs></breadcrumbs>
    <div class="content-wrapper">
        <div class="content-width">
          <h1> MULTIMODAL DANGEROUS GOODS FORM</h1>
          <p>
            Het Multimodal Dangerous Goods Form is een multimodaal vervoersdocument dat u kunt gebruiken voor het ADR vervoer van gevaarlijke stoffen. Dit formulier is geschikt voor:
          </p>
          <ul class="pretty">
            <li>Wegvervoer (ADR)</li>
            <li>Spoorvervoer (RID)</li>
            <li>Binnenvaart (IMDG-code)</li>
          </ul>
          <a :href="linkMMDGF" target="_blank"><button>
            <i class="fa download margin-right-small" />
            <span>Bekijk exemplaar</span>
          </button></a> 
          
          
<!--
          <h1>INSTRUCTIES BIJ NOODSITUATIES</h1>
          <p>
            Als hulpmiddel bij een noodsituatie die zich kan voordoen tijdens het vervoer, is het belangrijk om schriftelijke instructies bij de hand te hebben in de cabine van het voertuig.

          </p> 
          <a :href="linkRichtlijnen" target="_blank"><button>
            <i class="fa download margin-right-small" />
            <span>Bekijk exemplaar</span>
          </button></a> 
-->
        </div>
     </div>
</main>
</template>

<script>

import Breadcrumbs from './breadcrumbs'

export default {
  name: 'ContentTakenpakket',
  components: {
      Breadcrumbs
  },
  data () {
    return {
      linkMMDGF: require('../assets/MMDGF.pdf'),
      linkRichtlijnen: require('../assets/Richtlijnen_ADR.pdf'),
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/content-downloads.vue